import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-power-resource-needed',
  templateUrl: './power-resource-needed.component.html',
  styleUrls: ['./power-resource-needed.component.scss']
})
export class PowerResourceNeededComponent implements OnChanges {
  @Input() level: number;
  public powerNeeded: number;

  constructor(
  ) {
  }

  ngOnChanges() {
    this.powerNeeded = this.powerResourceNeededCalc(this.level);
  }

  powerResourceNeededCalc(level = 0): number {
    let sum = 0;

    for (let i = 0; i <= level; i++) {
      const pow = Math.pow(i, 1.15) * 1000;
      sum += Math.round(pow);
    }

    return sum;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/page-creep-level.module/power-resource-needed.component/power-resource-needed.component.ts